/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { ScanJob } from '../models/ScanJob';

export class GetScanJobResponse {
  'job': ScanJob;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "job",
      "baseName": "job",
      "type": "ScanJob",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GetScanJobResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

